import 'material-design-icons-iconfont/dist/material-design-icons.css'
import Vue from 'vue'
import Vuetify, {
  VApp,
  VTreeview,
  VIcon
} from 'vuetify/lib'

Vue.use(Vuetify, {
  components: {
    VApp,
    VTreeview,
    VIcon
  }
})

export default new Vuetify({
  icons: {
    iconfont: 'md'
  }
})
